/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
export const SET_AUTH = 'authActionTypes/SET_AUTH';
export const SET_AUTH_SUCCESS = 'authActionTypes/SET_AUTH_SUCCESS';
export const SET_AUTH_ERROR = 'authActionTypes/SET_AUTH_ERROR';


export interface SetAuth {
  type: typeof SET_AUTH;
  payload?:any,
};

export interface SetAuthSuccess {
  type: typeof SET_AUTH_SUCCESS;
  payload?: any;
};

export interface SetAuthError {
  type: typeof SET_AUTH_ERROR;
  payload?: any;
};
